/**
 * Feedback button (ADR-0074 §3.1).
 *
 * Sized + styled to match `NotificationBell` (its sibling in the topbar) —
 * uses the same `.menuButton` class and a 18px inline SVG icon.
 */

import { useRef, useState } from "react";
import { IconFeedback } from "./IconFeedback.js";
import { FeedbackPopover } from "./FeedbackPopover.js";

export function FeedbackButton() {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="menuButton"
        aria-label="Send feedback"
        title="Feedback"
        onClick={() => setOpen((v) => !v)}
      >
        <IconFeedback size={18} />
      </button>
      {open ? (
        <FeedbackPopover anchor={buttonRef.current} onClose={() => setOpen(false)} />
      ) : null}
    </>
  );
}
